import React, { Fragment } from 'react';

import { FormFlex, FormBox, FormGroupLoader } from 'components/shared/form';

function Loader() {
  return (
    <Fragment>
      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="4.25rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="13.75rem" />
        </FormBox>
      </FormFlex>

      <FormFlex>
        <FormBox width={1}>
          <FormGroupLoader labelWidth="3rem" />
        </FormBox>
      </FormFlex>
    </Fragment>
  );
}

export default Loader;
